import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ItemSize } from '../../../enums/sizeEnums';
import { AuthRoutes } from '../../../routes/routeConstants/appRoutes';
import ConditionalRender from '../../../shared/components/ConditionalRender';
import ResetForm from './ResetForm';
import { ResetScreen, LINK_ERROR_MESSAGE } from './constants';
import styles from './ResetPassword.module.scss';

interface ResetPasswordScreenProps {
  screen: ResetScreen;
  userName?: string;
}

const ResetPasswordScreen: React.FC<ResetPasswordScreenProps> = ({ screen, userName }) => {
  const navigate = useNavigate();
  const isError = screen === ResetScreen.EXPIRED || screen === ResetScreen.FAILED;

  return (
    <div className={styles.centeredContainer}>
      <div className={styles.innerContainer}>
        <div className={styles.header}>
          <h1>RESET PASSWORD</h1>
          <ConditionalRender visible={screen === ResetScreen.FORM}>
            <h4 className={styles.byLine}>
              If you would like to change the password for <span className={styles.highlightedName}>{userName}, </span>
              please enter and confirm a new password below.
            </h4>
          </ConditionalRender>
          <ConditionalRender visible={screen === ResetScreen.VERIFYING}>
            <p className={styles.byLine}>Please wait...</p>
          </ConditionalRender>
        </div>
        <ConditionalRender visible={screen === ResetScreen.FORM}>
          <ResetForm />
        </ConditionalRender>
        <ConditionalRender visible={isError}>
          <div className={styles.fieldsContainer}>
            <p className={styles.errorMessage}>{LINK_ERROR_MESSAGE}</p>
            <Button className={styles.actionButton} size={ItemSize.LARGE} onClick={() => navigate(AuthRoutes.FORGOT_PASSWORD)}>
              REQUEST NEW
            </Button>
          </div>
        </ConditionalRender>
      </div>
    </div>
  );
};

export default ResetPasswordScreen;
